import { mask } from 'remask';

export function maskAmount(value: string, digits?: number) {
  if (value === '' || value === undefined || value === null) return '';

  // Se 'digits' não for fornecido, usa ['99999']
  const amount = digits ? [Array(digits + 1).join('9')] : ['99999'];

  return mask(value, amount);
}
